import { useQueryClient } from '@tribeplatform/react-sdk/lib';
import { useMutation } from '../../lib';
import { useTribeClient } from '../../useTribeClient';
import { getAuthTokensKey } from '../../utils/keys/authToken.keys';
import { getNetworkKey } from '../../utils/keys/network.key';
export const useAddMemberSchemaField = (options) => {
    const { useMutationOptions, fields = 'default' } = options || {};
    const { client } = useTribeClient();
    const queryClient = useQueryClient();
    const networkKey = getNetworkKey();
    const authTokenKey = getAuthTokensKey();
    return useMutation(input => client.network.addMemberSchemaField(input, fields), {
        onMutate: variables => {
            queryClient.setQueryData(authTokenKey, old => {
                var _a, _b;
                return ({
                    ...old,
                    network: {
                        ...old === null || old === void 0 ? void 0 : old.network,
                        memberFields: {
                            fields: [...(_b = (_a = old === null || old === void 0 ? void 0 : old.network) === null || _a === void 0 ? void 0 : _a.memberFields) === null || _b === void 0 ? void 0 : _b.fields, variables === null || variables === void 0 ? void 0 : variables.input],
                        },
                    },
                });
            });
            queryClient.setQueryData(networkKey, old => {
                var _a;
                return ({
                    ...old,
                    memberFields: {
                        fields: [...(_a = old === null || old === void 0 ? void 0 : old.memberFields) === null || _a === void 0 ? void 0 : _a.fields, variables === null || variables === void 0 ? void 0 : variables.input],
                    },
                });
            });
        },
        onSettled: () => {
            queryClient.invalidateQueries(networkKey);
            queryClient.invalidateQueries(authTokenKey);
        },
        ...useMutationOptions,
    });
};
//# sourceMappingURL=useAddMemberSchemaField.js.map